import { Binder } from '@ribajs/core'
import { CountryProvinceSelector } from '../utils/index.js'

/**
 * This binder adds `odd` and `even` classes to table `tr` elements
 */
export class CountrySelectsBinder extends Binder<
  { default: string; formId: number },
  HTMLSelectElement
> {
  /** The name of the attribute, in this case you can use this binder with `rv-nutrient-table="true"` */
  static key = 'country-selects'

  /** This method is called every time the attribute values changes */
  routine(el: HTMLSelectElement, data: { default: string; formId: number }) {
    new CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew',
    })

    new CountryProvinceSelector(el, `AddressProvince_${data.formId}`, {
      hideElement: `AddressProvinceContainer_${data.formId}`,
    })
  }
}
